const initialState = [];
//
export default function cmSdepth0002(state = initialState, action) {
  switch (action.type) {
    case 'SET_CMSDEPTH0002':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CMSDEPTH0002_ERROR':
      return state;
    default:
      return state;
  }
}
